class CartDrawerUpsell extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.limit = this.dataset.limit || '4';

    if (!this.productId) {
      this.innerHTML = '';
      return;
    }

    const cacheKey = `${this.productId}-${this.limit}`;
    if (CartDrawerUpsell.cache.key === cacheKey && CartDrawerUpsell.cache.html !== null) {
      this.innerHTML = CartDrawerUpsell.cache.html;
      this.initSlider();
      return;
    }

    this.fetchRecommendations('complementary');
  }

  initSlider() {
    const sliderElement = this.querySelector('.cart-drawer-upsell__slider');
    if (!sliderElement || typeof Swiper === 'undefined') return;
    if (sliderElement.swiper) sliderElement.swiper.destroy(true, true);

    new Swiper(sliderElement, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: true,
      pagination: {
        el: this.querySelector('.cart-drawer-upsell__pagination'),
        clickable: true,
      },
      mousewheel: { forceToAxis: true, releaseOnEdges: true },
    });
  }

  fetchRecommendations(intent) {
    const url = `${this.dataset.url}?section_id=${this.dataset.sectionId}&product_id=${this.productId}&limit=${this.limit}&intent=${intent}`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        if (!this.isConnected) return;

        const html = new DOMParser().parseFromString(text, 'text/html');
        const content = html.querySelector('.cart-drawer-upsell__inner');

        if (content) {
          this.innerHTML = content.outerHTML;
          CartDrawerUpsell.cache = { key: `${this.productId}-${this.limit}`, html: this.innerHTML };
          this.initSlider();
        } else if (intent === 'complementary') {
          this.fetchRecommendations('related');
        } else {
          this.innerHTML = '';
          CartDrawerUpsell.cache = { key: `${this.productId}-${this.limit}`, html: '' };
        }
      })
      .catch(() => {
        this.innerHTML = '';
      });
  }
}

CartDrawerUpsell.cache = { key: null, html: null };

customElements.define('cart-drawer-upsell', CartDrawerUpsell);
